import React, { useEffect } from "react";
import { Container } from "reactstrap";
import AuthFunctions from '../services/AuthService';
import Session from '../auth/Session';
import { Roles } from '../auth/Roles';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CustomerGrid from "../layout/CustomerGrid";
import SubCustomerGrid from "../layout/SubCustomerGrid";
import DriverGrid from "../layout/DriverGrid";
import UserGrid from "../layout/UserGrid";
import RouteGrid from "../layout/RouteGrid";
import TransactionTypeGrid from "../layout/TransactionTypeGrid";
import SurchargeGrid from "../layout/SurchargeGrid";
import DriverSurchargeGrid from "../layout/DriverSurchargeGrid";
import FuelRateGrid from "../layout/FuelRateGrid";
import QuickBooksPanel from "./QuickBooksPanel";

const FINANCE_MANAGER_TABS = ["surcharges", "driversurcharges", "fuelrates", "routes", "drivers"];
const ADMIN_TABS = [
    "users",
    "customers",
    "subcustomers",
    "surcharges",
    "driversurcharges",
    "fuelrates",
    "routes",
    "drivers",
    "transactiontypes",
    "quickbooks",
];

function Admin() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const isAdmin = Session.hasRole(Roles.Admin);
    const isFinanceManager = Session.hasRole(Roles.FinanceManager);
    const allowedTabs = isAdmin ? ADMIN_TABS : (isFinanceManager ? FINANCE_MANAGER_TABS : []);
    const defaultTab = allowedTabs[0] || "";
    const requestedTab = searchParams.get("tab");
    const activeTab = requestedTab && allowedTabs.includes(requestedTab) ? requestedTab : defaultTab;

    useEffect(() => {
        const check = async () => {
            const isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
            if (!isAuthenticated) {
                navigate('/logout');
                return;
            }
            if (!isAdmin && !isFinanceManager) {
                navigate('/');
            }
        };
        check();
    }, [navigate, isAdmin, isFinanceManager]);

    if (!isAdmin && !isFinanceManager) {
        return null;
    }

    return (
        <Container fluid className="p-4">
            {activeTab === "users" && isAdmin && <UserGrid />}
            {activeTab === "customers" && isAdmin && <CustomerGrid />}
            {activeTab === "subcustomers" && isAdmin && <SubCustomerGrid />}
            {activeTab === "routes" && <RouteGrid />}
            {activeTab === "drivers" && <DriverGrid />}
            {activeTab === "transactiontypes" && isAdmin && <TransactionTypeGrid />}
            {activeTab === "surcharges" && <SurchargeGrid />}
            {activeTab === "driversurcharges" && <DriverSurchargeGrid />}
            {activeTab === "fuelrates" && <FuelRateGrid />}
            {activeTab === "quickbooks" && isAdmin && <QuickBooksPanel />}
        </Container>
    );
}

export default Admin;
